define(
    'views/admin_reports.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/admin_reports.html'
    ],
    function(Loader, Config, Helper, Sandbox, adminReportsTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var AdminReportsView = Loader.Backbone.View.extend(
            {

                list: [],

                events: Helper.prepareEventsForDevice(
                    {
                        'click .mark-report-as-read': 'markAsRead'
                    },
                    Loader.eventType
                ),

                routes: {
                    "/admin_index.php[?+]act=reports": "preparePage"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');
                    var user =  this.model.get('users').getMe();

                    this.model.on('startApplication', function(){
                        if ((user.get('groupId') == 1 || user.get('groupId') == 2)
                            && Config.modules.reports.enabled){

                            Helper.filterRoutes(_this.routes, _this);

                            _this.model.get('adminMenuLinks').add([{
                                id: 'reports-link',
                                className: 'item30',
                                title: 'Жалобы',
                                href: '/admin_index.php?act=reports',
                                indicator: 0,
                                position: 21,
                                isActive: (document.location.href.indexOf('?act=reports') != -1)
                            }]);
                        }
                    });

                    this.model.get('forum').get('reports').bind('update', this.render)

                    this.model.get('forum').bind('change:unreadReports', function(){
                        var unreadReports = _this.model.get('forum').get('unreadReports');
                        _this.model.get('adminMenuLinks').get('reports-link').set('indicator', unreadReports);
                    });
                },

                render: function(global)
                {
                    if (global) return this;

                    if (Config.modules.notes.enabled == false) return this;

                    var elem = $("#pun-admain1");

                    var compiledTemplate = _.template(
                        adminReportsTemplate,
                        {
                            model: this.model.toJSON(),
                            user: this.model.get('users').getMe().toJSON(),
                            list: this.model.get('forum').get('reports').toJSON(),
                            Helper: Helper
                        }
                    );

                    elem.html(compiledTemplate);
                    return this;
                },

                preparePage: function()
                {
                    var _this = this;
                    document.title = 'Администрирование — Жалобы';

                    this.render();

                    this.model.get('forum').getReports();
                },

                markAsRead: function(e)
                {
                    e && e.preventDefault();
                    var reportId = $(e.currentTarget).attr('data-id');
                    if (!reportId) return;

                    this.model.get('forum').markReportAsRead({
                        reports_id: [reportId]
                    }, function(){
                        location.reload(true);
                    }, function(){
                        alert('!!Произошла ошибка выполнении операции');
                        location.reload(true);
                    });
                }
            });

        return {
            initialize: function(model)
            {
                return new AdminReportsView({
                    el: $("#pun-admain"),
                    model: model
                })
            }
        }
    }
);
